module.exports = "# Mission Assignment\n\nTitle: Keep Building Your Kit\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: 86B6X8UUbkg\n\n## Notes\n\nIan and Sara introduce Mission 3 - We're In This Together (2:47).\n\n# Instructions\n\n## Content\n\n### Mission 3:\n\n#### Keep getting more prepared!\n* Keep building your kit!\n* Talk with friends and family about emergency preparedness.\n* Keep practising your Superhero Calming Breath!\n\n## Notes\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridPrimaries/sections/70_missionAssignment/level3_keepBuildingKit.md
// module id = 1583
// module chunks = 2